(function () {
  'use strict';

  /* @ngdoc object
   * @name events.list
   * @description
   *
   */
  angular
    .module('events.list', [
      'ui.router'
    ]);
}());
